<template>
<div class="cover">
	<section>
		<div>
			<slot></slot>
		</div>
	</section>
</div>
</template>


<script>

export default {

	name: "Cover",

}

</script>